<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div class="form-group">
        <el-form-item>
          <label
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Field Title
            <span class="text-red-500">*</span>
          </label>
          <el-input
            type="text"
            maxlength="200"
            v-model="field.label"
            placeholder="Enter Field Title"
          ></el-input>
          <p v-if="field.label && !field.label.length" class="error">*Title is required*</p>

          <FormError error-key="label" />
        </el-form-item>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="form-group">
        <el-form-item>
          <label
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Description
          </label>
          <el-input
            type="textarea"
            v-model="field.description"
            placeholder="Enter Description Here"
          ></el-input>
          <FormError error-key="description" />
        </el-form-item>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import FormError from '@/components/form/FormError';
  export default {
    components: { FormError },
    props: ['field'],
    data() {
      return {};
    },
  };
</script>

<style lang="scss"></style>
